import { atom } from 'recoil';

export interface FutureRouteStop {
  id: string;
  status: string;
  clientName: string;
  clientAddress: string;
  estimated_gallons: number;
  estimated_barrel: number;
  serviceStop: string;
  serviceType: string;
}

export interface FutureRoute {
  id: string;
  date: string;
  route_name: string;
  service: string;
  status: string;
  stop_count: number;
  stops: FutureRouteStop[];
}

export const futureRoutesStateAtom = atom<FutureRoute[]>({
  key: 'futureRoutesState',
  default: [],
});
